import React, { useContext, useState, useEffect, useRef } from "react";
import {
  Button,
  Typography,
  Grid,
  Container,
  Divider,
  List,
  ListItem,
  ListItemText,
  Box,
  Card,
  CardContent,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Paper,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { Alert } from "@mui/material";

import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";

import {
  eliminarItemCarrito,
  confirmarReserva,
  obtenerMuestroCarrito,
  obtenerDatosHotel,
  graboReservaEnAdmintour,
  obtenerReservasMotor,
  grabarPagoTransbank,
  obtenerImagenCabezal,
  envioCorreo,
  marcarReservaMotor,
} from "../../services/motorService";

import RoomTypeRatePlanContext from "../contexts/RoomTypeRatePlanContext";
import RoomsContext from "../contexts/RoomsContext";
import CheckoutContext from "../contexts/CheckoutContext";
import useSession from "../../services/session";

import PersonalData from "../personalData/PersonalData";
import Payment from "../payment/Payment";
import Cookies from "js-cookie";

const Checkout = () => {
  const alreadyProcessedRef = useRef(false);
  const bannerFetchedRef = useRef(false);
  const hotelFetchedRef = useRef(false);

  const BASE_URL = "/MotorReservasAdmintour";
  //const BASE_URL = "/QAMotorReservasAdmintour";

  const { cartItems, setCartItems, setReservaAdmintour, reservaAdmintour } =
    useContext(RoomTypeRatePlanContext);

  const { updateRoom } = useContext(RoomsContext);

  const {
    formValues,
    setFormValues,
    resetCheckout,
  } = useContext(CheckoutContext);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const session = useSession();

  const params = new URLSearchParams(location.search);
  const hotcodParam = params.get("hotcod");
  const hotCod = hotcodParam ?? Cookies.get("hotCod") ?? null;

  const buildUrl = (path) => {
    const qs = new URLSearchParams(location.search);
    qs.set("hotcod", hotCod);

    return `${BASE_URL}${path}?${qs.toString()}`;
  };

  const status = searchParams.get("status");
  const sesion = searchParams.get("sesion");
  const numeroReservaMotor = searchParams.get("NumeroReservaMotor");
  const amount = searchParams.get("amount");
  const buyOrder = searchParams.get("buy_order");
  const card_number = searchParams.get("card_number");

  const fromWebPay = status === "AUTHORIZED" || status === "FAILED";

  const [datosHotel, setDatosHotel] = useState({});
  const [tarjetaEnGarantia, setTarjetaEnGarantia] = useState(null);
  const [loading, setLoading] = useState(true);
  const [bannerUrl, setBannerUrl] = useState(null);

  const [isFormValid, setIsFormValid] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [openFailedDialog, setOpenFailedDialog] = useState(false);

  const [processing, setProcessing] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  const [aceptaTerminosTransferencia, setAceptaTerminosTransferencia] =
    useState(false);

  const isWebpayAuthorized =
    fromWebPay &&
    status === "AUTHORIZED" &&
    (tarjetaEnGarantia === "S" || tarjetaEnGarantia === "B");

  /* const EMPTY_FORM = {
     reservanombre: "",
     motorreservanombretitular: "",
     motorreservaapellidotitular: "",
     reservatipodocumento: "",
     reservadocumento: "",
     reservatelefono: "",
     correoElectronico: "",
     reservadireccion: "",
     reservafechanacimiento: null,
     reservapais: "",
     reservaautocolor: "",
     reservaautomarca: "",
     reservaautomatricula: "",
     reservaobservaciones: "",
   };*/

  const EMPTY_FORM = {
    reservanombre: "",
    motorreservanombretitular: "",
    motorreservaapellidotitular: "",
    reservatipodocumento: "",
    reservadocumento: "",
    reservatelefono: "",
    correoElectronico: "",
    reservadireccion: "",
    reservafechanacimiento: null,
    reservapais: "",
    reservaautocolor: "",
    reservaautomarca: "",
    reservaautomatricula: "",
    reservaobservaciones: "",
    paymentMethodCode: "",
    paymentMethodLabel: "",
    paymentMethodGroup: "",
    paymentType: "",
  };

  // -----------------------
  // VALIDACIONES
  // -----------------------
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePhone = (phone) => /^[0-9]+$/.test(phone);

  // -----------------------
  // STEPS
  // -----------------------
  const steps = [
    {
      label: "Datos Personales",
      component: (
        <PersonalData
          formValues={formValues}
          setFormValues={setFormValues}
          setIsFormValid={setIsFormValid}
        />
      ),
    },
    {
      label: "Método de Pago",
      component: (
        <Payment
          aceptaTerminosTransferencia={aceptaTerminosTransferencia}
          setAceptaTerminosTransferencia={setAceptaTerminosTransferencia}
          onBeforeWebpay={handleSaveBookBeforeWebpay}
        />
      ),
    },
    {
      label: "Reserva Finalizada",
      component: (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 3 }}>
          {status === "AUTHORIZED" &&
            (tarjetaEnGarantia === "S" || tarjetaEnGarantia === "B") && (
              <Alert
                severity="success"
                sx={{
                  backgroundColor: "#d4edda",
                  color: "#155724",
                  border: "1px solid #c3e6cb",
                }}
              >
                {tarjetaEnGarantia === "S" ? (
                  <>
                    ¡Transacción exitosa! Se ha procesado correctamente el pago de su
                    estadía por un total de{" "}
                    <strong>CLP {Number(amount).toLocaleString("es-CL")}</strong>.
                  </>
                ) : (
                  <>
                    ¡Transacción exitosa! Se ha procesado correctamente el pago del
                    <strong> 50% de la reserva</strong> por un total de{" "}
                    <strong>CLP {Number(amount).toLocaleString("es-CL")}</strong>.
                  </>
                )}
              </Alert>
            )}
        </Box>
      ),
    },
  ];

  // -----------------------
  // CARGA INICIAL (solo una vez por hotCod)
  // -----------------------
  useEffect(() => {
    const savedForm = localStorage.getItem("checkoutForm");
    const savedStep = localStorage.getItem("checkoutStep");

    // ⚠️ Antes, si Checkout se montaba y NO veníamos de WebPay, se pisaba
    // formValues con EMPTY_FORM y se borraba "checkoutForm" de localStorage
    // sin condición. Eso pasa, por ejemplo, cuando el cliente ya cargó su
    // documento (quedó con los campos de titular bloqueados en PersonalData)
    // y usa la flecha "atrás" del navegador: Checkout se desmonta y, al
    // volver a montarse, esto blanqueaba el documento y el nombre. Como el
    // bloqueo de esos campos depende de que haya datos de titular cargados,
    // quedaban editables y se podía terminar la reserva a nombre de otra
    // persona. CheckoutProvider ya hidrata formValues (y rutCliente) desde
    // localStorage apenas se monta el contexto, así que acá NO hace falta
    // (ni conviene) volver a pisarlo: si venimos de WebPay, refrescamos con
    // lo último guardado antes del redirect; si no, dejamos lo que ya trajo
    // el contexto tal cual.
    if (fromWebPay && savedForm) {
      try {
        setFormValues(JSON.parse(savedForm));
      } catch (e) {
        // JSON corrupto: dejamos lo que ya trae el contexto en vez de
        // blanquear el formulario.
      }
    }

    if (fromWebPay && savedStep) {
      try {
        setActiveStep(JSON.parse(savedStep));
      } catch (e) {
        setActiveStep(0);
      }
    } else {
      setActiveStep(0);
      localStorage.setItem("checkoutStep", JSON.stringify(0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // <- importante: solo 1 vez

  useEffect(() => {
    if (!hotCod) return;

    const run = async () => {
      try {
        // Banner
        if (!bannerFetchedRef.current) {
          bannerFetchedRef.current = true;
          try {
            const imagenBase64 = await obtenerImagenCabezal(hotCod);
            if (
              imagenBase64 &&
              !imagenBase64.startsWith(
                "Imagen del Cabezal Sin Datos para el hotel"
              )
            ) {
              setBannerUrl(`data:image/png;base64,${imagenBase64}`);
            }
          } catch (e) {
            console.error("Error fetching header image:", e);
          }
        }

        // Datos hotel
        if (!hotelFetchedRef.current) {
          hotelFetchedRef.current = true;
          const data = await obtenerDatosHotel(hotCod);
          setDatosHotel(data);
          setTarjetaEnGarantia(data.MotorHotSolTarjeta);
          setLoading(false);
        }
      } catch (e) {
        console.error("Error inicializando Checkout:", e);
      }
    };

    run();
  }, [hotCod]);

  // -----------------------
  // Persistencia del form: la maneja CheckoutContext.js (mismo debounce,
  // misma key "checkoutForm"). Tener este mismo efecto acá duplicado hacía
  // que, 250ms después de un resetCheckout() (reserva ya procesada / cliente
  // abandona), este efecto volviera a escribir formValues en localStorage
  // (aunque fuera el objeto vacío) — quitamos la duplicación.
  // -----------------------

  // -----------------------
  // Derivar reservanombre sin loop (solo si cambia)
  // -----------------------
  useEffect(() => {
    const fullName =
      `${formValues.motorreservanombretitular || ""} ${formValues.motorreservaapellidotitular || ""
        }`.trim();

    if (fullName && formValues.reservanombre !== fullName) {
      setFormValues((prev) => ({
        ...prev,
        reservanombre: fullName,
      }));
    }
  }, [
    formValues.motorreservanombretitular,
    formValues.motorreservaapellidotitular,
    formValues.reservanombre,
    setFormValues,
  ]);

  // -----------------------
  // Validación del paso 0 (sin disparar llamadas a APIs)
  // -----------------------
  useEffect(() => {
    const isCorreoValido =
      (formValues.correoElectronico || "").trim() &&
      validateEmail(formValues.correoElectronico);

    const isTelefonoValido =
      (formValues.reservatelefono || "").trim() &&
      validatePhone(formValues.reservatelefono);

    const isValid =
      (formValues.motorreservanombretitular || "").trim() &&
      (formValues.motorreservaapellidotitular || "").trim() &&
      (formValues.reservanombre || "").trim() &&
      formValues.reservatipodocumento &&
      (formValues.reservadocumento || "").trim() &&
      isTelefonoValido &&
      isCorreoValido &&
      (formValues.reservadireccion || "").trim() &&
      formValues.reservafechanacimiento &&
      formValues.reservapais;

    setIsFormValid(Boolean(isValid));
  }, [
    formValues.motorreservanombretitular,
    formValues.motorreservaapellidotitular,
    formValues.reservanombre,
    formValues.reservatipodocumento,
    formValues.reservadocumento,
    formValues.reservatelefono,
    formValues.correoElectronico,
    formValues.reservadireccion,
    formValues.reservafechanacimiento,
    formValues.reservapais,
  ]);

  // -----------------------
  // Cargar carrito (sin loops)
  // -----------------------
  useEffect(() => {
    const cargarCarrito = async () => {
      try {
        const ses = fromWebPay ? sesion : session;
        if (!hotCod || !ses) return;
        const carrito = await obtenerMuestroCarrito(hotCod, ses);
        setCartItems(Array.isArray(carrito) ? carrito : []);
      } catch (e) {
        console.error("No se pudo obtener el carrito en Checkout:", e);
      }
    };
    cargarCarrito();
  }, [hotCod, session, fromWebPay, status, sesion, setCartItems]);

  const limpiarCarritoBackend = async () => {
    try {
      const carrito = await obtenerMuestroCarrito(hotCod, session);
      if (Array.isArray(carrito)) {
        for (const item of carrito) {
          await eliminarItemCarrito(hotCod, session, item.CarritoItemLinea);
        }
      }
    } catch (error) {
      console.error("Error limpiando el carrito en backend:", error);
    }
  };

  // -----------------------
  // Manejo automático al volver de WebPay (1 sola vez)
  // -----------------------
  useEffect(() => {
    if (alreadyProcessedRef.current) return;

    if (
      status === "AUTHORIZED" &&
      (tarjetaEnGarantia === "S" || tarjetaEnGarantia === "B")
    ) {
      alreadyProcessedRef.current = true;
      setProcessing(true);
      setActiveStep(2);
      localStorage.setItem("checkoutStep", JSON.stringify(2));
      handleConfirmFromWebPay();
    } else if (
      status === "FAILED" &&
      (tarjetaEnGarantia === "S" || tarjetaEnGarantia === "B")
    ) {
      alreadyProcessedRef.current = true;
      setOpenFailedDialog(true);
      limpiarCarritoBackend();
      setCartItems([]);
      resetCheckout?.();
    }
  }, [status, tarjetaEnGarantia]); // <- mínimo

  // -----------------------
  // Email helpers (no los toco, solo los dejo)
  // -----------------------
  const fmt = (d) => {
    const x = new Date(d);
    const dd = String(x.getUTCDate()).padStart(2, "0");
    const mm = String(x.getUTCMonth() + 1).padStart(2, "0");
    const yy = x.getUTCFullYear();
    return `${dd}/${mm}/${yy}`;
  };

  /*const buildEmailPayload = (numeroReservaPreferido) => {
    const ci = cartItems?.[0]?.CarritoItemDesde ? fmt(cartItems[0].CarritoItemDesde) : "";
    const co = cartItems?.[0]?.CarritoItemHasta ? fmt(cartItems[0].CarritoItemHasta) : "";
    console.log("cart items en el build payload", cartItems);
    const items = (cartItems || []).map((it) => ({
      tipoHab: it.CarritoItemTipoHab,
      tarifa: it.CarritoItemTarifa,
      adultos: it.CarritoItemMayores,
      menores: it.CarritoItemMenores,
      totalHabitacion: `${Number(it.CarritoItemTotal || 0).toLocaleString("es-ES", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} ${it.CarritoItemMoneda || ""}`,
    }));

    const total = (Array.isArray(cartItems)
      ? cartItems.reduce((acc, it) => acc + Number(it.CarritoItemTotal || 0), 0)
      : 0
    ).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const moneda = cartItems?.[0]?.CarritoItemMoneda || "";

    const nombre = `${formValues?.motorreservanombretitular || ""} ${formValues?.motorreservaapellidotitular || ""
      }`.trim();
    const email = formValues?.correoElectronico || "";

    return {
      nombre,
      email,
      numeroReserva: (reservaAdmintour || "").split(" ")[0] || numeroReservaPreferido || "",
      checkin: ci,
      checkout: co,
      hotelNombre: datosHotel?.TituloCarta || "",
      textoIntroHotel: datosHotel?.MotorHotTextoConf || "",
      condiciones: datosHotel?.Condiciones || "",
      politicas: datosHotel?.MotorHotNormas || "",
      hotelTelefono: datosHotel?.MotorHotTelefono || "",
      hotelCorreo: datosHotel?.MotorHotCorreo || "",
      hotelHorario: datosHotel?.MotorHotHorario || "",
      moneda,
      total,
      items,
    };
  };*/
  const buildEmailPayload = (numeroReservaPreferido, carritoParam = cartItems) => {
    const carrito = Array.isArray(carritoParam) ? carritoParam : [];

    const ci = carrito?.[0]?.CarritoItemDesde ? fmt(carrito[0].CarritoItemDesde) : "";
    const co = carrito?.[0]?.CarritoItemHasta ? fmt(carrito[0].CarritoItemHasta) : "";

    const items = carrito.map((it) => ({
      tipoHab: it.CarritoItemTipoHab,
      tarifa: it.CarritoItemTarifa,
      adultos: it.CarritoItemMayores,
      menores: it.CarritoItemMenores,
      totalHabitacion: `${Number(it.CarritoItemTotal || 0).toLocaleString("es-ES", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} ${it.CarritoItemMoneda || ""}`,
    }));

    const total = carrito
      .reduce((acc, it) => acc + Number(it.CarritoItemTotal || 0), 0)
      .toLocaleString("es-ES", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    const moneda = carrito?.[0]?.CarritoItemMoneda || "";

    const nombre = `${formValues?.motorreservanombretitular || ""} ${formValues?.motorreservaapellidotitular || ""
      }`.trim();

    return {
      nombre,
      email: formValues?.correoElectronico || "",
      numeroReserva: numeroReservaPreferido || "",
      checkin: ci,
      checkout: co,
      hotelNombre: datosHotel?.TituloCarta || "",
      textoIntroHotel: datosHotel?.MotorHotTextoConf || "",
      condiciones: datosHotel?.Condiciones || "",
      politicas: datosHotel?.MotorHotNormas || "",
      hotelTelefono: datosHotel?.MotorHotTelefono || "",
      hotelCorreo: datosHotel?.MotorHotCorreo || "",
      hotelHorario: datosHotel?.MotorHotHorario || "",
      moneda,
      total,
      items,
    };
  };

  /*const sendReservationEmail = async (numeroReservaPreferido) => {
    const payload = buildEmailPayload(numeroReservaPreferido);
    console.log("payload email:", payload);
    if (!payload.email) return;
    try {
      await envioCorreo(JSON.stringify(payload));
    } catch (e) {
      console.warn("No se pudo enviar el correo de confirmación:", e);
    }
  };*/

  const sendReservationEmail = async (numeroReservaPreferido, sessionToUse = session) => {
    try {
      let carritoParaMail = cartItems;

      if (!Array.isArray(carritoParaMail) || carritoParaMail.length === 0) {
        carritoParaMail = await obtenerMuestroCarrito(hotCod, sessionToUse);
      }

      const payload = buildEmailPayload(numeroReservaPreferido, carritoParaMail);

      if (!payload.email) return;

      await envioCorreo(JSON.stringify(payload));
    } catch (e) {
      console.warn("Falló el correo de confirmación, pero la reserva continúa:", e);
    }
  };

  // -----------------------
  // Navegación steps
  // -----------------------
  const handleNext = () => {
    const newStep = activeStep + 1;
    setActiveStep(newStep);
    localStorage.setItem("checkoutStep", JSON.stringify(newStep));
  };

  const handleBack = () => setActiveStep((p) => p - 1);

  const handleErrorDialogClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;

    setErrorDialogOpen(false);
    limpiarCarritoBackend?.();
    setCartItems?.([]);
    resetCheckout?.();
    //navigate(`${BASE_URL}/disponibilidad/habitaciones?hotcod=${hotCod}`);
    navigate(buildUrl("/disponibilidad/habitaciones"));
  };

  // -----------------------
  // Observaciones: para AEBU (30/31), si el método de pago elegido es
  // "Red Pagos" (paymentMethodGroup === "RED_COBRANZA"), anteponemos el
  // aviso "A PAGAR EN RED PAGOS" sin pisar lo que haya escrito el pax.
  // -----------------------
  const buildObservaciones = () => {
    const observacionesBase = (formValues.reservaobservaciones || "").trim();

    const esRedPagosAebu =
      requiresPaymentMethodSelection &&
      formValues.paymentMethodGroup === "RED_COBRANZA";

    if (!esRedPagosAebu) return formValues.reservaobservaciones;

    return observacionesBase
      ? `A PAGAR EN RED PAGOS - ${observacionesBase}`
      : "A PAGAR EN RED PAGOS";
  };

  // -----------------------
  // Confirmación normal (transferencia / sin WebPay)
  // -----------------------
  const handleConfirm = async () => {
    try {
      setProcessing(true);

      const nombreDeLaReserva = `${formValues.motorreservanombretitular} ${formValues.motorreservaapellidotitular}`;
      const reserva = await confirmarReserva(
        hotCod,
        session,
        nombreDeLaReserva,
        formValues.motorreservanombretitular,
        formValues.motorreservaapellidotitular,
        formValues.reservatelefono,
        formValues.correoElectronico,
        formValues.reservadireccion,
        formValues.reservatelefono,
        formValues.reservapais,
        formValues.reservatipodocumento,
        formValues.reservadocumento,
        formValues.reservafechanacimiento,
        formValues.reservaautocolor,
        formValues.reservaautomarca,
        formValues.reservaautomatricula,
        buildObservaciones()
      );

      const reservaOk =
        reserva &&
        typeof reserva.okgraboreserva === "string" &&
        reserva.okgraboreserva.startsWith("Se grabó la Reserva con Líneas");

      if (!reservaOk) {
        setErrorDialogOpen(true);
        await limpiarCarritoBackend();
        setCartItems([]);
        resetCheckout?.();
        setProcessing(false);
        return;
      }

      const reservaMotorCod = reserva.nroReserva;
      console.log("reservadel motor:", reserva);

      // Hoteles 30/31: todavía no tienen el pago real conectado (el
      // selector de método de pago en Payment.js es ficticio, no dispara
      // ninguna pasarela). Igual queremos poder confirmar la reserva y que
      // se grabe en Admintour al tocar "Confirmar reserva", más allá de lo
      // que diga MotorUsaChannel para estos dos hoteles.
      const esHotelDePagoPersonalizado =
        String(hotCod) === "30" || String(hotCod) === "31";

      if (datosHotel.MotorUsaChannel === "N" || esHotelDePagoPersonalizado) {
        console.log("reservaMotorCod", reservaMotorCod);
        console.log("codigohotel", hotCod);
        const reservaDelMotor = await obtenerReservasMotor(hotCod, reservaMotorCod);
        const stdMotorReserva = reservaDelMotor.SDT_MotorReserva;
        const codigoEnAdmintour = datosHotel.MotorHotAdmintour;
        console.log("reservamotor:", reservaDelMotor);
        /*stdMotorReserva[0].MotorReservaPagMoneda =
          reservaDelMotor.SDT_MotorReserva[0].MotorReservaMonPago;
        stdMotorReserva[0].MotorReservaPagImportre =
          reservaDelMotor.SDT_MotorReserva[0].MotorReservaImpPago;
        */
        if (!Array.isArray(stdMotorReserva) || stdMotorReserva.length === 0) {
          // Sin líneas pendientes en el motor: no hay nada nuevo que
          // grabar en Admintour (evita el TypeError de .textoreserva
          // sobre un resultado inexistente).
          console.log(
            "Reserva sin líneas pendientes en el motor. No se reintenta el grabado en Admintour."
          );
        } else {
          const marcoLeidaMotor = await marcarReservaMotor(hotCod, reservaMotorCod);
          console.log("Marco leida", marcoLeidaMotor);
          const reservaAdm = await graboReservaEnAdmintour(
            codigoEnAdmintour,
            reservaMotorCod,
            stdMotorReserva
          );

          if (reservaAdm && reservaAdm.textoreserva) {
            const nro = reservaAdm.textoreserva.split(":")[1].trim();
            setReservaAdmintour(nro);

            await sendReservationEmail(nro);
          } else {
            console.log("NO SE GRABO LA RESERVA EN ADMINTOUR");
            setErrorDialogOpen(true);
          }
        }
      }

      localStorage.removeItem("sessionData");
      localStorage.removeItem("checkoutStep");
      // ✅ Reserva confirmada: limpiamos form + rutCliente (localStorage y
      // contexto) para que una PRÓXIMA reserva no arranque con el titular
      // (o el documento bloqueado) de esta.
      resetCheckout?.();
      //navigate(`${BASE_URL}/resumenReserva?hotcod=${hotCod}`);
      navigate(buildUrl("/resumenReserva"));
    } catch (error) {
      console.error("Error al confirmar la reserva:", error);
    } finally {
      setProcessing(false);
    }
  };

  // -----------------------
  // PRE WebPay: graba reserva en motor y guarda nro
  // -----------------------
  async function handleSaveBookBeforeWebpay() {
    try {
      const nombreDeLaReserva = `${formValues.motorreservanombretitular} ${formValues.motorreservaapellidotitular}`;

      const reserva = await confirmarReserva(
        hotCod,
        session,
        nombreDeLaReserva,
        formValues.motorreservanombretitular,
        formValues.motorreservaapellidotitular,
        formValues.reservatelefono,
        formValues.correoElectronico,
        formValues.reservadireccion,
        formValues.reservatelefono,
        formValues.reservapais,
        formValues.reservatipodocumento,
        formValues.reservadocumento,
        formValues.reservafechanacimiento,
        formValues.reservaautocolor,
        formValues.reservaautomarca,
        formValues.reservaautomatricula,
        formValues.reservaobservaciones
      );

      const reservaOk =
        reserva &&
        typeof reserva.okgraboreserva === "string" &&
        reserva.okgraboreserva.startsWith("Se grabó la Reserva con Líneas");

      if (!reservaOk) {
        setErrorDialogOpen(true);
        await limpiarCarritoBackend();
        setCartItems([]);
        resetCheckout?.();
        return false;
      }

      localStorage.setItem("reservaEnMotor", reserva.nroReserva);
      return reserva.nroReserva;
    } catch (e) {
      console.error("Error al grabar la reserva pre-Webpay:", e);
      await limpiarCarritoBackend();
      setCartItems([]);
      resetCheckout?.();
      setErrorDialogOpen(true);
      return false;
    }
  }

  // -----------------------
  // Volver de WebPay: enviar a Admintour una sola vez (marca más única)
  // -----------------------
  const handleConfirmFromWebPay = async () => {
    try {
      if (!numeroReservaMotor) {
        console.warn("No hay NumeroReservaMotor; no se puede continuar.");
        setProcessing(false);
        setErrorDialogOpen(true);
        return;
      }

      const processedKey = `reservaMotorProcesada_${hotCod}_${numeroReservaMotor}`;

      if (localStorage.getItem(processedKey) === "S") {
        console.log("Reserva ya enviada a Admintour, no se reenvía.");
        setProcessing(false);
        //navigate(`${BASE_URL}/resumenReserva?hotcod=${hotCod}`);
        navigate(buildUrl("resumenReserva"));
        return;
      }

      if (datosHotel.MotorUsaChannel === "N") {
        const reservaDelMotor = await obtenerReservasMotor(hotCod, numeroReservaMotor);
        const stdMotorReserva = reservaDelMotor.SDT_MotorReserva;
        const codigoEnAdmintour = datosHotel.MotorHotAdmintour;

        console.log("RESERVA GRABADA EN EL MOTOR:", reservaDelMotor);

        if (!Array.isArray(stdMotorReserva) || stdMotorReserva.length === 0) {
          console.log(
            "Reserva ya procesada previamente (sin líneas pendientes en el motor). No se reintenta el grabado en Admintour."
          );

          await sendReservationEmail(numeroReservaMotor, sesion);

          
          localStorage.setItem(processedKey, "S");
          localStorage.removeItem("reservaEnMotor");
          localStorage.removeItem("sessionData");
          localStorage.removeItem("checkoutStep");
          resetCheckout?.();
          setProcessing(false);
          navigate(buildUrl("/resumenReserva"));
          return;
        }

        /*stdMotorReserva[0].MotorReservaPagMoneda =
          reservaDelMotor.SDT_MotorReserva[0].MotorReservaMonPago;
        stdMotorReserva[0].MotorReservaPagImportre =
          reservaDelMotor.SDT_MotorReserva[0].MotorReservaImpPago;
        */
        const reservaAdm = await graboReservaEnAdmintour(
          codigoEnAdmintour,
          numeroReservaMotor,
          stdMotorReserva
        );
        console.log("codigo admintour", codigoEnAdmintour);
        console.log("numeroReservaMotor", numeroReservaMotor);
        console.log("SDTMotor", stdMotorReserva);
        console.log("RESERVA EN ADMINTOUR", reservaAdm);

        if (reservaAdm.textoreserva) {
          const nro = reservaAdm.textoreserva.split(":")[1].trim();
          setReservaAdmintour(nro);
          const marcoLeidaMotor = await marcarReservaMotor(hotCod, numeroReservaMotor);
          console.log("Marco leida", marcoLeidaMotor);

          localStorage.setItem(processedKey, "S");
          console.log("nrooooo", nro);
          //sendReservationEmail(nro);
          sendReservationEmail(nro, sesion);
        } else {
          console.log("NO SE GRABO LA RESERVA EN ADMINTOUR");
          setProcessing(false);
          setErrorDialogOpen(true);
          return;
        }
      }

      localStorage.removeItem("reservaEnMotor");
      localStorage.removeItem("sessionData");
      localStorage.removeItem("checkoutStep");
      resetCheckout?.();

      //navigate(`${BASE_URL}/resumenReserva?hotcod=${hotCod}`);
      navigate(buildUrl("/resumenReserva"));
    } catch (error) {
      console.error("Error al confirmar la reserva desde WebPay:", error);
      setErrorDialogOpen(true);
    } finally {
      setProcessing(false);
    }
  };

  // -----------------------
  // UI helpers
  // -----------------------
  const handleDeleteItem = async (lineNumber) => {
    try {
      await eliminarItemCarrito(hotCod, session, lineNumber);
      const updatedCart = await obtenerMuestroCarrito(hotCod, session);
      setCartItems(updatedCart || []);
      updateRoom(lineNumber, false);

      if (!updatedCart || updatedCart.length === 0) {
        // ✅ Carrito realmente vacío: acá SÍ corresponde blanquear todo,
        // incluido el rutCliente persistido (resetCheckout se encarga de
        // limpiar también "checkoutRutCliente" en localStorage).
        resetCheckout?.();
        setOpenDialog(true);
      }
    } catch (error) {
      console.error("Error al eliminar el ítem del carrito:", error);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    resetCheckout?.();
    //navigate(`${BASE_URL}/disponibilidad?hotcod=${hotCod}`);
    navigate(buildUrl("/disponibilidad"));
  };

  const totalImporte = Array.isArray(cartItems)
    ? cartItems.reduce((total, item) => total + parseFloat(item.CarritoItemTotal || 0), 0)
    : 0;

  const formatoNumero = (valor) =>
    parseFloat(valor).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const formatTitleDate = () => {
    if (cartItems && cartItems.length > 0) {
      const checkinDate = new Date(cartItems[0].CarritoItemDesde);
      const checkoutDate = new Date(cartItems[0].CarritoItemHasta);

      const fullcheckinData =
        checkinDate.getUTCDate() + "/" + (checkinDate.getUTCMonth() + 1) + "/" + checkinDate.getUTCFullYear();

      const fullcheckoutData =
        checkoutDate.getUTCDate() + "/" + (checkoutDate.getUTCMonth() + 1) + "/" + checkoutDate.getUTCFullYear();

      return fullcheckinData + " - " + fullcheckoutData;
    }
    return "";
  };

  const obtengoCarritoMoneda = (carrito) => (carrito?.[0]?.CarritoItemMoneda ? carrito[0].CarritoItemMoneda : "");
  const requiresPaymentMethodSelection =
    String(hotCod) === "30" || String(hotCod) === "31";

  const requiresPaymentProviderSelection =
    requiresPaymentMethodSelection &&
    formValues.paymentMethodCode === "TARJETAS_BANCOS";

  console.log("Checkout render", formValues.paymentType);
  // -----------------------
  // RENDER
  // -----------------------
  return (
    <Container sx={{ mt: 5 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <Stepper activeStep={activeStep} orientation="vertical">
            {steps.map((step, index) => (
              <Step key={step.label}>
                <StepLabel>{step.label}</StepLabel>
                <StepContent>
                  {step.component}
                  <Box sx={{ mb: 2 }}>
                    <div>
                      {activeStep === steps.length - 1 ? (
                        isWebpayAuthorized ? null : (
                          <>
                            <Button onClick={handleBack} sx={{ ml: 1 }}>
                              Atrás
                            </Button>
                            <Button
                              variant="contained"
                              onClick={() => {
                                setProcessing(true);
                                handleConfirm();
                              }}
                            >
                              Confirmar reserva
                            </Button>
                          </>
                        )
                      ) : (
                        <>
                          {index === 1 ? (
                            requiresPaymentMethodSelection ? (
                              // AEBU (30/31): el selector de método de pago es
                              // propio (no dispara Webpay/Compra Aquí), así que
                              // el "Siguiente" acá NO debe depender de
                              // tarjetaEnGarantia/status de Webpay — eso rompía
                              // el flujo cuando el hotel tenía configurado
                              // MotorHotSolTarjeta = "S", dejando el botón
                              // esperando una autorización de Webpay que nunca
                              // iba a llegar.
                              <>
                                <Button onClick={handleBack} sx={{ ml: 1 }}>
                                  Atrás
                                </Button>
                                <Button
                                  variant="contained"
                                  onClick={handleNext}
                                  disabled={
                                    !aceptaTerminosTransferencia ||
                                    !formValues.paymentMethodCode
                                  }
                                >
                                  Siguiente
                                </Button>
                              </>
                            ) : (
                              (
                                (tarjetaEnGarantia === "S" && !formValues.paymentType) ||
                                formValues.paymentType === "COMPRA_AQUI"
                              ) ? (
                              <>
                                {status === "FAILED" && (
                                  <Alert
                                    severity="error"
                                    sx={{
                                      backgroundColor: "#f8d7da",
                                      color: "#721c24",
                                      border: "1px solid #f5c6cb",
                                      mb: 3,
                                    }}
                                  >
                                    Ha fallado la transacción por{" "}
                                    <strong>CLP {Number(amount).toLocaleString("es-CL")}</strong>. <br />
                                    Pruebe nuevamente.
                                  </Alert>
                                )}

                                {status === "AUTHORIZED" && (
                                  <Alert
                                    severity="success"
                                    sx={{
                                      backgroundColor: "#d4edda",
                                      color: "#155724",
                                      border: "1px solid #c3e6cb",
                                      mb: 3,
                                    }}
                                  >
                                    Transacción Exitosa!
                                  </Alert>
                                )}

                                <Button onClick={handleBack} sx={{ ml: 1 }}>
                                  Atrás
                                </Button>
                                <Button
                                  variant="contained"
                                  onClick={handleNext}
                                  disabled={status !== "AUTHORIZED"}
                                >
                                  Siguiente
                                </Button>
                              </>
                            ) : (
                              <>
                                <Button onClick={handleBack} sx={{ ml: 1 }}>
                                  Atrás
                                </Button>
                                <Button
                                  variant="contained"
                                  onClick={handleNext}
                                  disabled={
                                    !aceptaTerminosTransferencia ||
                                    (tarjetaEnGarantia === "B" && !formValues.paymentType) ||
                                    (requiresPaymentMethodSelection && !formValues.paymentMethodCode)
                                  }
                                >
                                  Siguiente
                                </Button>
                              </>
                            )
                            )
                          ) : (
                            <>
                              <Button disabled={index === 0} onClick={handleBack} sx={{ ml: 1 }}>
                                Atrás
                              </Button>
                              <Button
                                variant="contained"
                                onClick={handleNext}
                                disabled={index === 0 && !isFormValid}
                              >
                                Siguiente
                              </Button>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </Box>
                </StepContent>
              </Step>
            ))}
          </Stepper>

          {activeStep === steps.length && (
            <Paper square elevation={0} sx={{ p: 3 }}>
              <Typography>Todos los pasos completados - ¡La reserva está lista!</Typography>
            </Paper>
          )}
        </Grid>

        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography gutterBottom variant="h6" component="div">
                Detalles del carrito
              </Typography>

              {cartItems && cartItems.length > 0 ? (
                <>
                  <Typography variant="body2" color="textSecondary">
                    {formatTitleDate()}{" "}
                    {`/ ${Math.round(
                      (new Date(cartItems[0].CarritoItemHasta) - new Date(cartItems[0].CarritoItemDesde)) /
                      (1000 * 60 * 60 * 24)
                    )} noche(s)`}
                  </Typography>

                  <Divider />

                  <List>
                    {cartItems.map((item, index) => (
                      <div key={item.CarritoItemLinea}>
                        <ListItem alignItems="flex-start">
                          <ListItemText
                            primary={
                              <>
                                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                                  {item.CarritoItemTipoHab}
                                </Typography>
                                <Typography variant="body1">{item.CarritoItemTarifa}</Typography>
                              </>
                            }
                            secondary={
                              <Typography component="div" color="textSecondary" sx={{ marginTop: 2 }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                  <Typography variant="body2" color="textSecondary">
                                    {`${item.CarritoItemMayores} adulto(s), ${item.CarritoItemMenores} menor(es)`}
                                  </Typography>
                                  <Typography variant="body2" color="textSecondary">
                                    {`${formatoNumero(item.CarritoItemTotal)} ${item.CarritoItemMoneda}`}
                                  </Typography>
                                </Box>
                              </Typography>
                            }
                          />
                          <IconButton edge="end" color="inherit" onClick={() => handleDeleteItem(item.CarritoItemLinea)}>
                            <DeleteIcon />
                          </IconButton>
                        </ListItem>
                        {index < cartItems.length - 1 && <Divider />}
                      </div>
                    ))}

                    <Divider />
                    <Typography component="div" sx={{ marginTop: 2 }}>
                      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                          Total
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                          {totalImporte.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}{" "}
                          {obtengoCarritoMoneda(cartItems)}
                        </Typography>
                      </Box>
                    </Typography>
                  </List>
                </>
              ) : (
                <Typography variant="subtitle1" color="text.secondary">
                  No hay elementos en el carrito.
                </Typography>
              )}
            </CardContent>

            <CardContent>
              <Box display="flex" justifyContent="center" sx={{ marginBottom: 2 }}>
                <Button
                  variant="outlined"
                  color="secondary"
                  //onClick={() => navigate(`${BASE_URL}/disponibilidad?hotcod=${hotCod}`)}
                  onClick={() => navigate(buildUrl("/disponibilidad"))}
                  sx={{ width: "100%" }}
                >
                  Seguir comprando
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Carrito Vacío</DialogTitle>
        <DialogContent>
          <DialogContentText>
            No hay más elementos en el carrito. Serás redirigido a la página de disponibilidad.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={errorDialogOpen} onClose={handleErrorDialogClose}>
        <DialogTitle>Error</DialogTitle>
        <DialogContent>
          <DialogContentText>Ocurrió un error al generar la reserva, por favor vuelva a intentarlo.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setErrorDialogOpen(false);
              //navigate(`${BASE_URL}/disponibilidad/habitaciones?hotcod=${hotCod}`);
              navigate(buildUrl("/disponibilidad/habitaciones"));
            }}
            color="primary"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openFailedDialog}
        onClose={() => {
          setOpenFailedDialog(false);
          //navigate(`${BASE_URL}/disponibilidad?hotcod=${hotCod}`);
          navigate(buildUrl("/disponibilidad"));
        }}
      >
        <DialogTitle>Error de Transacción</DialogTitle>
        <DialogContent>
          <DialogContentText>
            La transacción ha fallado. Serás redirigido a la pantalla de disponibilidad para que puedas intentar nuevamente
            tu reserva.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenFailedDialog(false);
              //navigate(`${BASE_URL}/disponibilidad?hotcod=${hotCod}`);
              navigate(buildUrl("/disponibilidad"));
            }}
            color="primary"
            autoFocus
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Backdrop open={processing} sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}>
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress />
          <Typography sx={{ mt: 2, fontWeight: 600 }}>
            Estamos procesando su reserva, por favor no cierre la pantalla.
          </Typography>
        </Box>
      </Backdrop>
    </Container>
  );
};

export default Checkout;